import React from "react";
import { Navigate } from "react-router-dom";
import { useSubscription } from "./useSubscription";

const ProtectedRoute2 = ({ children }) => {
    const { isLoading, isPremium } = useSubscription();

    // ✅ DO NOT evaluate before loading completes
    if (isLoading) {
        return <div className="text-center mt-4">Loading...</div>;
    }

    // ✅ NOW safe to check
    if (!isPremium) {return <Navigate to="/seller/subscription" replace />;
    }
    
    return children;
};

export default ProtectedRoute2;